import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    DuplicateSalesDocument as DuplicateSalesDocumentMutation,
    DuplicateSalesDocumentVariables as DuplicateSalesDocumentVariables,
    SalesDocumentDuplicateInput,
} from 'nutshell-graphql-types';

import DUPLICATE_SALES_DOCUMENT from '../mutations/duplicate-sales-document.graphql';

export const useDuplicateSalesDocument = (): {
    duplicateSalesDocument: (arg1: SalesDocumentDuplicateInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [duplicateSalesDocument, {loading, error}] = useMutation<
        DuplicateSalesDocumentMutation,
        DuplicateSalesDocumentVariables
    >(DUPLICATE_SALES_DOCUMENT);

    return {
        duplicateSalesDocument: (input: SalesDocumentDuplicateInput) =>
            duplicateSalesDocument({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
